export default "__VITE_ASSET__nRusEJkS__"